// extracted by mini-css-extract-plugin
export default {"warning":"warning___ZKDqB"};